

import { ReactNode } from 'react';
import dynamic from 'next/dynamic';
import { LayoutGroup } from 'framer-motion';

const ToastContainer = dynamic(
  () => import('@/components/ui/toast').then((mod) => mod.ToastContainer),
  { ssr: false }
);

const TutorialOverlay = dynamic(
  () => import('@/components/tutorial/TutorialOverlay').then((mod) => mod.TutorialOverlay),
  { ssr: false }
);

interface ProvidersProps {
  children: ReactNode;
}

export function Providers({ children }: ProvidersProps) {
  return (
    <LayoutGroup id="fp-app-shell">
      {children}
      <ToastContainer />
      <TutorialOverlay />
    </LayoutGroup>
  );
}
